<template>
  <v-app>
    <div>
      <div v-if="this.auth.currentUser">
        <PaymentsHeader/>
        <HostedFields/>
      </div>
    </div>
    <DashboardFooter />
  </v-app>
</template>

<script>
import HostedFields from '@/components/BraintreePayments/HostedFields';
import PaymentsHeader from '@/components/BraintreePayments/PaymentsHeader';
import firebase from '../scripts/firebase'
import DashboardFooter from '@/components/Dashboard/DashboardFooter';
import {mapGetters} from 'vuex';

export default {
  name: "Payments",
  data() {
    return {
      auth: '',

    }
  },
  components: {DashboardFooter, PaymentsHeader, HostedFields},
  mounted() {
    this.auth = firebase.auth();

    if (!this.$store.getters.user.loggedIn) {
      console.error('NOT LOGGED IN')
      this.$router.push('/login')
    }
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  }
}
</script>

<style scoped>

</style>
